import React, { useEffect, useMemo, useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsIcon from '@mui/icons-material/Payments';

const currency = new Intl.NumberFormat('fr-MA', {
  style: 'currency',
  currency: 'MAD',
  maximumFractionDigits: 2,
});

const PaymentPanel = ({ methods, totals, onAddPayment, payments, onRemovePayment, onConfirm, disabled }) => {
  const [selectedMethod, setSelectedMethod] = useState('');
  const [amount, setAmount] = useState('');

  const remaining = totals.remaining;
  const canConfirm = remaining === 0 && payments.length > 0;

  const selected = useMemo(
    () => methods.find((method) => method._id === selectedMethod),
    [methods, selectedMethod]
  );

  useEffect(() => {
    if (!selectedMethod && methods.length > 0) {
      setSelectedMethod(methods[0]._id);
    }
  }, [methods, selectedMethod]);

  useEffect(() => {
    if (remaining > 0) {
      setAmount(remaining.toFixed(2));
    }
  }, [remaining]);

  const handleAddPayment = () => {
    if (!selected || !amount) return;
    const numericAmount = Number(amount);
    if (!Number.isFinite(numericAmount) || numericAmount <= 0) return;
    const isCash = selected.code?.toLowerCase() === 'cash';
    if (!isCash && numericAmount > remaining) return;
    onAddPayment({
      id: `${selected._id}-${Date.now()}`,
      payment_method_id: selected._id,
      name: selected.name,
      amount: numericAmount,
    });
    setAmount('');
  };

  return (
    <div className="pos-payment-card">
      <div className="pos-payment-due">
        <div>
          <div className="pos-eyebrow">Encaissement</div>
          <span>Restant a payer</span>
        </div>
        <strong>{currency.format(remaining)}</strong>
      </div>

      <div className="pos-method-grid">
        {methods.map((method) => {
          const isSelected = selectedMethod === method._id;
          const Icon = method.code?.toLowerCase() === 'cash' ? PaymentsIcon : CreditCardIcon;
          return (
            <button
              type="button"
              key={method._id}
              className={`pos-method-button ${isSelected ? 'is-active' : ''}`}
              onClick={() => setSelectedMethod(method._id)}
            >
              <Icon fontSize="small" />
              <span>{method.name}</span>
            </button>
          );
        })}
        {methods.length === 0 && <div className="pos-empty-state compact">Aucun moyen de paiement actif.</div>}
      </div>

      <div className="pos-payment-add">
        <input
          type="number"
          placeholder="Montant"
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
        />
        <button type="button" onClick={handleAddPayment} disabled={!selectedMethod || !amount || remaining <= 0}>
          Ajouter
        </button>
      </div>

      <div className="pos-payment-list">
        {payments.map((payment) => (
          <div key={payment.id} className="pos-payment-row">
            <div>
              <div>{payment.name}</div>
              <span>{currency.format(payment.amount)}</span>
            </div>
            <button type="button" onClick={() => onRemovePayment(payment.id)}>
              Retirer
            </button>
          </div>
        ))}
      </div>

      <button className="pos-confirm-button" type="button" disabled={!canConfirm || disabled} onClick={onConfirm}>
        <CheckCircleOutlineIcon />
        {disabled ? 'Enregistrement...' : 'Confirmer la vente'}
      </button>
    </div>
  );
};

export default PaymentPanel;
